/* eslint-disable no-undef */
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { RouteList } from '@zg-rentals/route-list';
import Page from '@zg-rentals/multibrand-ui/lib/Page';
import PageNotFound from '@zg-rentals/multibrand-ui/lib/PageNotFound';
import styled from 'styled-components';

const StyledRouteList = styled(RouteList)`
  position: absolute;
  z-index: 1;
  width: 100%;
`;

const NotFoundPage = ({ brand }) => (
  <Page noPadding className="NotFoundPage">
    <PageNotFound brand={brand} />
    {__DEV__ && <StyledRouteList />}
  </Page>
);

NotFoundPage.propTypes = {
  brand: PropTypes.string,
};

export default connect((state) => ({
  brand: state.app.brand,
}))(NotFoundPage);
